<template>
  <div>
    <v-row dense align="start">
      <v-col cols="6">
        <v-text-field
        :label="$t('latitude')"
        id="bid-location-latitude"
        v-model="latitude"
        :readonly="disabled"
        :rules="[rules.required, rules.decimal, rules.validLatitudeForTextBox, rules.sixDecimalPlacesOrFewer]"
        type="number"
        color="black"
        dense
        hide-details="auto"
        hide-spin-buttons
        @change="emitLocation"/>
      </v-col>
      <v-col cols="6">
        <v-text-field
        :label="$t('longitude')"
        id="bid-location-longitude"
        v-model="longitude"
        :readonly="disabled"
        :rules="[rules.required, rules.decimal, rules.validLongitudeForTextBox, rules.sixDecimalPlacesOrFewer]"
        type="number"
        color="black"
        dense
        hide-details="auto"
        hide-spin-buttons
        @change="emitLocation"/>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
        :label="$t('state')"
        autocomplete="disabled"
        id="bid-location-state"
        :items="states"
        :readonly="disabled"
        :rules="[rules.required]"
        color="black"
        item-color="primary"
        dense
        hide-details="auto"
        v-model="countrySubdivision"
        @change="stateChanged"/>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
        :label="$t('county')"
        autocomplete="disabled"
        id="bid-location-county"
        :items="selectedCounties"
        :readonly="disabled"
        :rules="[rules.required]"
        color="black"
        item-color="primary"
        dense
        hide-details="auto"
        v-model="countrySecondarySubdivision"
        @change="emitLocation"/>
      </v-col>
    </v-row>
    <v-dialog v-model="showMap" max-width="900px" persistent>
      <BidLocationMapDialog
      v-if="showMap"
      :propLocation="mapLocation"
      @selected-location="onMapSelected"
      @close="showMap = false"/>
    </v-dialog>
  </div>
</template>

<script>
import fieldRules from '@/utils/rules'
import counties from '@/utils/state-counties.json'

export default {
  name: 'BidLocationForm',

  components: {
    BidLocationMapDialog: () => import('@/components/bid/BidLocationMapDialog.vue')
  },

  props: {
    spot: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      rules: fieldRules.rules,
      showMap: false,
      latitude: this.spot.latitude,
      longitude: this.spot.longitude,
      countrySubdivision: this.spot.countrySubdivision,
      countrySecondarySubdivision: this.spot.countrySecondarySubdivision
    }
  },

  computed: {
    states () {
      return Object.keys(counties)
    },

    mapLocation () {
      const lat = parseFloat(this.latitude)
      const lon = parseFloat(this.longitude)
      if (isNaN(lat) || isNaN(lon)) return undefined
      return { latitude: lat, longitude: lon }
    },

    selectedCounties () {
      if (counties[this.countrySubdivision] === undefined) return []
      const names = counties[this.countrySubdivision].map(c => c.N)
      if (this.countrySecondarySubdivision === 'Franklin' || this.countrySecondarySubdivision === 'Bedford') names.push(this.countrySecondarySubdivision)
      return names
    }
  },

  watch: {
    spot: {
      handler (spot) {
        this.latitude = spot.latitude
        this.longitude = spot.longitude
        this.countrySubdivision = spot.countrySubdivision
        this.countrySecondarySubdivision = spot.countrySecondarySubdivision
      },
      deep: true
    }
  },

  methods: {
    openMap () {
      this.showMap = true
    },

    stateChanged () {
      const county = counties[this.countrySubdivision]?.[0]
      this.countrySecondarySubdivision = county?.N
      // Lat/long precede state in the form now — only seed county centroid coords when the user hasn't entered any.
      if (county && this.mapLocation === undefined) {
        const coords = county.C.split(',')
        this.latitude = parseFloat(coords[0])
        this.longitude = parseFloat(coords[1])
      }
      this.emitLocation()
    },

    onMapSelected (spot) {
      this.latitude = spot.latitude
      this.longitude = spot.longitude
      if (spot.countrySubdivision) this.countrySubdivision = spot.countrySubdivision
      if (spot.countrySecondarySubdivision) this.countrySecondarySubdivision = spot.countrySecondarySubdivision
      this.emitLocation()
      this.showMap = false
    },

    emitLocation () {
      this.$emit('location-changed', {
        latitude: this.latitude !== null && this.latitude !== '' ? parseFloat(this.latitude) : undefined,
        longitude: this.longitude !== null && this.longitude !== '' ? parseFloat(this.longitude) : undefined,
        countrySubdivision: this.countrySubdivision,
        countrySecondarySubdivision: this.countrySecondarySubdivision
      })
    }
  }
}
</script>
